// extracted by mini-css-extract-plugin
export default {"splash_actions":"list_splash_actions__pCGhJ"};